import { AuthMethodLink } from './_auth_method_link.component';
import { AuthMethods } from './_auth_methods.component';
import { AuthSignInButton } from './_auth_sign_in_button.component';
import { AuthSignInError } from './_auth_sign_in_error.component';
import { AuthSignInSheet } from './_auth_sign_in_sheet.component';
import { AuthSignOutButton } from './_auth_sign_out_button.component';

export const Auth = {
	SignInError: AuthSignInError,
	MethodLink: AuthMethodLink,
	Methods: AuthMethods,
	SignInSheet: AuthSignInSheet,
	SignInButton: AuthSignInButton,
	SignOutButton: AuthSignOutButton,
};
